export default "__VITE_ASSET__BLX_inbY__"